import { map } from 'lodash'
import { createSelector } from 'reselect'

export const getRevenueCenters = (state) => state?.revenueCenters?.byId

export const getRevenueCentersNames = createSelector(
  getRevenueCenters,
  (revenueCenters) => {
    return map(revenueCenters, (revenueCenter) => revenueCenter?.name)
  }
)

export const getRevenueCentersUuids = createSelector(
  getRevenueCenters,
  (revenueCenters) => {
    return map(revenueCenters, (revenueCenter) => revenueCenter?.uuid)
  }
)
